import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';


@Component({
  selector: 'app-profile-image',
  templateUrl: './profile-image.component.html',
  styleUrls: ['./profile-image.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: []
})
export class ProfileImageComponent implements OnInit {
  @Input() imageUrl: string = '';
  @Input() alt: string = 'Foto de perfil';
  @Input() width: number = 36;
  @Input() height: number = 36;
  @Input() cssClass: string = '';

  public displayImageUrl: string = '';

  ngOnInit(): void {
    this.setDisplayImage();
  }

  ngOnChanges(): void {
    this.setDisplayImage();
  }

  private setDisplayImage(): void {
    if (!this.imageUrl || this.imageUrl.includes('default-profile.png')) {
      this.displayImageUrl = '/assets/images/default-profile.png';
    } else {
      this.displayImageUrl = this.imageUrl;
    }
  }
} 